__turbopack_context__.v({
  "stack": "HostImageStack-module-scss-module__sFsQdG__stack",
});
